import React, { Component, Fragment } from "react";
import { Grid, } from '@material-ui/core';
import Pane from './containers/Pane';
import { LoadingProgress } from './containers/LoadingProgress';

class TermDates extends Component {

  componentDidMount() {
    this.props.onRefreshTermDates();
  }

  createMarkup() {
    return {__html: this.props.termDates[0][this.props.appLanguage]};
  }

  render() {
    const { termDates, translations, appLanguage } = this.props;
    return (
      <Fragment>
        <Grid container justify="center">
          <Grid item xs sm={9} lg={8} xl={7}>
            <Pane header={translations.t_MODULE_TERMDATES_TITLE[appLanguage]}>
              <LoadingProgress data={termDates}>
                {termDates.length > 0 ? 
                <div dangerouslySetInnerHTML={this.createMarkup()} /> 
                :null}
              </LoadingProgress>
            </Pane>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default TermDates;


// WEBPACK FOOTER //
// ./src/components/TermDates.js